'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getLevel = require('./get-level');

var _getLevel2 = _interopRequireDefault(_getLevel);

var _hasChildren = require('./has-children');

var _hasChildren2 = _interopRequireDefault(_hasChildren);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var toggleChildren = function toggleChildren() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getIndex = _ref.getIndex,
      getIndex = _ref$getIndex === undefined ? function (rowData) {
    return rowData._index;
  } : _ref$getIndex,
      getRows = _ref.getRows,
      getShowingChildren = _ref.getShowingChildren,
      toggleShowingChildren = _ref.toggleShowingChildren,
      props = _ref.props,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      parentField = _ref.parentField,
      _ref$toggleEvent = _ref.toggleEvent,
      toggleEvent = _ref$toggleEvent === undefined ? 'DoubleClick' : _ref$toggleEvent;

  if (!getRows) {
    throw new Error('tree.toggleChildren - Missing getRows!');
  }

  if (!getShowingChildren) {
    throw new Error('tree.toggleChildren - Missing getShowingChildren!');
  }

  if (!toggleShowingChildren) {
    throw new Error('tree.toggleChildren - Missing toggleShowingChildren!');
  }

  var toggle = function toggle(e, index) {
    e.stopPropagation();
    e.preventDefault();

    toggleShowingChildren(index);
  };

  return function (value, extra) {
    var _ref2 = props || {},
        className = _ref2.className,
        restProps = _objectWithoutProperties(_ref2, ['className']); // eslint-disable-line react/prop-types


    var rows = getRows();
    var showingChildren = getShowingChildren(extra);
    var index = getIndex(extra.rowData);
    var containsChildren = (0, _hasChildren2.default)({ index: index, idField: idField, parentField: parentField })(rows) ? 'has-children' : '';
    var level = (0, _getLevel2.default)({ index: index, idField: idField, parentField: parentField })(rows);
    var hasParent = level > 0 ? 'has-parent' : '';

    var hasAutomaticIndentation = (0, _get3.default)(props, 'indent', true);

    var events = _defineProperty({}, 'on' + toggleEvent, function undefined(e) {
      toggle(e, index);
      window.getSelection && window.getSelection().removeAllRanges();
    });

    var style = hasAutomaticIndentation ? { paddingLeft: level + 'em' } : {};

    return _react2.default.createElement(
      'div',
      _extends({
        style: style,
        className: containsChildren + ' ' + hasParent + ' ' + (className || '')
      }, events, restProps),
      containsChildren && _react2.default.createElement('span', {
        className: showingChildren ? 'show-less' : 'show-more',
        onClick: function onClick(e) {
          return toggle(e, index);
        }
      }),
      value
    );
  };
};

exports.default = toggleChildren;